import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DoServisuPredal = {
	name: NAME,
	apiProvider,
	router,
};
